function n(t = 1) {
  return {
    h1: {
      fontFamily: "Athletics-Light",
      fontSize: 60 * t,
      lineHeight: 60 * t
    },
    h2: {
      fontFamily: "Athletics-Light",
      fontSize: 48 * t,
      lineHeight: 52 * t
    },
    h3: {
      fontFamily: "Athletics-Black",
      fontSize: 40 * t,
      lineHeight: 44 * t,
      letterSpacing: 1,
      textTransform: "uppercase"
    },
    h4: {
      fontFamily: "Athletics-Medium",
      fontSize: 28 * t,
      lineHeight: 32 * t
    },
    h5: {
      fontFamily: "Athletics-Black",
      fontSize: 24 * t,
      lineHeight: 28 * t,
      letterSpacing: 1,
      textTransform: "uppercase"
    },
    h6: {
      fontFamily: "Athletics-Bold",
      fontSize: 18 * t,
      lineHeight: 24 * t
    },
    quote: {
      fontFamily: "Athletics-Light",
      fontSize: 32 * t,
      lineHeight: 40 * t
    },
    body1: {
      fontFamily: "UntitledSans-Regular",
      fontSize: 16 * t,
      lineHeight: 24 * t
    },
    body1Medium: {
      fontFamily: "UntitledSans-Medium",
      fontSize: 16 * t,
      lineHeight: 24 * t
    },
    body2: {
      fontFamily: "UntitledSans-Regular",
      fontSize: 14 * t,
      lineHeight: 20 * t
    },
    body3: {
      fontFamily: "UntitledSans-Regular",
      fontSize: 12 * t,
      lineHeight: 18 * t
    },
    eyebrow1: {
      fontFamily: "Athletics-Black",
      fontSize: 16 * t,
      lineHeight: 20 * t,
      letterSpacing: 1,
      textTransform: "uppercase"
    },
    eyebrow2: {
      fontFamily: "Athletics-Bold",
      fontSize: 12 * t,
      lineHeight: 20 * t,
      letterSpacing: 1,
      textTransform: "uppercase"
    },
    cta1: {
      fontFamily: "UntitledSans-Medium",
      fontSize: 16 * t,
      lineHeight: 20 * t
    },
    cta2: {
      fontFamily: "UntitledSans-Medium",
      fontSize: 14 * t,
      lineHeight: 20 * t
    },
    cta3: {
      fontFamily: "UntitledSans-Medium",
      fontSize: 12 * t,
      lineHeight: 18 * t
    },
    ah1: {
      fontFamily: "Athletics-Light",
      fontSize: 64 * t,
      lineHeight: 72 * t
    },
    "ah1-bold": {
      fontFamily: "Athletics-Bold",
      fontSize: 64 * t,
      lineHeight: 72 * t
    },
    "ah1-black": {
      fontFamily: "Athletics-Black",
      fontSize: 64 * t,
      lineHeight: 72 * t
    },
    ah2: {
      fontFamily: "Athletics-Light",
      fontSize: 48 * t,
      lineHeight: 56 * t
    },
    "ah2-bold": {
      fontFamily: "Athletics-Bold",
      fontSize: 48 * t,
      lineHeight: 56 * t
    },
    "ah2-black": {
      fontFamily: "Athletics-Black",
      fontSize: 48 * t,
      lineHeight: 56 * t
    },
    ah3: {
      fontFamily: "Athletics-Light",
      fontSize: 32 * t,
      lineHeight: 40 * t
    },
    "ah3-bold": {
      fontFamily: "Athletics-Bold",
      fontSize: 32 * t,
      lineHeight: 40 * t
    },
    "ah3-black": {
      fontFamily: "Athletics-Black",
      fontSize: 32 * t,
      lineHeight: 40 * t
    },
    ah4: {
      fontFamily: "Athletics-Light",
      fontSize: 24 * t,
      lineHeight: 32 * t
    },
    "ah4-bold": {
      fontFamily: "Athletics-Bold",
      fontSize: 24 * t,
      lineHeight: 32 * t
    },
    "ah4-black": {
      fontFamily: "Athletics-Black",
      fontSize: 24 * t,
      lineHeight: 32 * t
    },
    ab1: {
      fontFamily: "Athletics-Regular",
      fontSize: 20 * t,
      lineHeight: 28 * t
    },
    "ab1-bold": {
      fontFamily: "Athletics-Bold",
      fontSize: 20 * t,
      lineHeight: 28 * t
    },
    "ab1-black": {
      fontFamily: "Athletics-Black",
      fontSize: 20 * t,
      lineHeight: 28 * t
    },
    ab2: {
      fontFamily: "Athletics-Regular",
      fontSize: 16 * t,
      lineHeight: 22 * t
    },
    "ab2-bold": {
      fontFamily: "Athletics-Bold",
      fontSize: 16 * t,
      lineHeight: 22 * t
    },
    "ab2-black": {
      fontFamily: "Athletics-Black",
      fontSize: 16 * t,
      lineHeight: 22 * t
    },
    ab3: {
      fontFamily: "Athletics-Regular",
      fontSize: 14 * t,
      lineHeight: 20 * t
    },
    "ab3-bold": {
      fontFamily: "Athletics-Bold",
      fontSize: 14 * t,
      lineHeight: 20 * t
    },
    "ab3-black": {
      fontFamily: "Athletics-Black",
      fontSize: 14 * t,
      lineHeight: 20 * t
    },
    ac1: {
      fontFamily: "Athletics-Bold",
      fontSize: 32 * t,
      lineHeight: 36 * t,
      letterSpacing: 1,
      textTransform: "uppercase"
    },
    "ac1-black": {
      fontFamily: "Athletics-Black",
      fontSize: 32 * t,
      lineHeight: 36 * t,
      letterSpacing: 1,
      textTransform: "uppercase"
    },
    ac2: {
      fontFamily: "Athletics-Bold",
      fontSize: 20 * t,
      lineHeight: 24 * t,
      letterSpacing: 1,
      textTransform: "uppercase"
    },
    "ac2-black": {
      fontFamily: "Athletics-Black",
      fontSize: 20 * t,
      lineHeight: 24 * t,
      letterSpacing: 1,
      textTransform: "uppercase"
    },
    ac3: {
      fontFamily: "Athletics-Bold",
      fontSize: 16 * t,
      lineHeight: 20 * t,
      letterSpacing: 1,
      textTransform: "uppercase"
    },
    "ac3-black": {
      fontFamily: "Athletics-Black",
      fontSize: 16 * t,
      lineHeight: 20 * t,
      letterSpacing: 1,
      textTransform: "uppercase"
    },
    ac4: {
      fontFamily: "Athletics-Bold",
      fontSize: 12 * t,
      lineHeight: 16 * t,
      letterSpacing: 1,
      textTransform: "uppercase"
    },
    "ac4-black": {
      fontFamily: "Athletics-Black",
      fontSize: 12 * t,
      lineHeight: 16 * t,
      letterSpacing: 1,
      textTransform: "uppercase"
    },
    ub1: {
      fontFamily: "UntitledSans-Regular",
      fontSize: 16 * t,
      lineHeight: 24 * t
    },
    "ub1-bold": {
      fontFamily: "UntitledSans-Medium",
      fontSize: 16 * t,
      lineHeight: 24 * t
    },
    ub2: {
      fontFamily: "UntitledSans-Regular",
      fontSize: 14 * t,
      lineHeight: 20 * t
    },
    "ub2-bold": {
      fontFamily: "UntitledSans-Medium",
      fontSize: 14 * t,
      lineHeight: 20 * t
    },
    ub3: {
      fontFamily: "UntitledSans-Regular",
      fontSize: 12 * t,
      lineHeight: 16 * t
    },
    "ub3-bold": {
      fontFamily: "UntitledSans-Medium",
      fontSize: 12 * t,
      lineHeight: 16 * t
    }
  };
}
export {
  n as default
};
//# sourceMappingURL=text.js.map
